// src/pages/Vehiculo.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function LugaresAdmim() {
  const [lugares, setLugares] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  const API_URL_IMG = process.env.REACT_APP_API_URL_IMG_LT;
  const [selectedLugar, setSelectedLugar] = useState(null);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [infoDestacada, setInfoDestacada] = useState('');
  const [sabiasQue, setSabiasQue] = useState('');
  const [urlMapa, setUrlMapa] = useState('');
  const [imagenPrincipal, setImagenPrincipal] = useState(null);
  const [galeria, setGaleria] = useState([]);
  const [referencias, setReferencias] = useState([
    { nombre: '', comentario: '', estrellas: 5 },
  ]);

  const [cronograma, setCronograma] = useState('');
  const [precios, setPrecios] = useState('');
  const [precioAdultos, setPrecioAdultos] = useState('');
  const [precioNinos, setPrecioNinos] = useState('');

  const [isEditing, setIsEditing] = useState(false);




  const handleDeleteLugar = (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${API_URL}lugares-turisticos/${id}`)
          .then(() => {
            setLugares((prev) => prev.filter((lugar) => lugar.id !== id));
            Swal.fire('Eliminado', 'El lugar ha sido eliminado', 'success');
          })
          .catch((err) => {
            console.error('Error al eliminar lugar:', err);
            Swal.fire('Error', 'No se pudo eliminar el lugar', 'error');
          });
      }
    });
  };

  const handleReferenciaChange = (index, field, value) => {
    const nuevas = [...referencias];
    nuevas[index][field] = value;
    setReferencias(nuevas);
  };

  const agregarReferencia = () => {
    setReferencias([...referencias, { nombre: '', comentario: '', estrellas: 5 }]);
  };

  const eliminarReferencia = (index) => {
    const nuevas = referencias.filter((_, i) => i !== index);
    setReferencias(nuevas);
  };

  const handlePrincipalChange = (e) => {
    setImagenPrincipal(e.target.files[0]);
  };

  const handleGaleriaChange = (e) => {
    const files = Array.from(e.target.files);
    setGaleria((prev) => [...prev, ...files]);
  };

  const removeGaleriaImage = (index) => {
    setGaleria((prev) => prev.filter((_, i) => i !== index));
  };

  // Al crear un nuevo lugar
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('nombre', nombre);
    formData.append('descripcion', descripcion);
    formData.append('info_destacada', infoDestacada);
    formData.append('sabias_que', sabiasQue);
    formData.append('url_mapa', urlMapa);
    formData.append('cronograma', cronograma);
    formData.append('precios', precios);

    // NUEVOS
    formData.append('precio_adultos', precioAdultos);
    formData.append('precio_ninos', precioNinos);

    formData.append('referencias', JSON.stringify(referencias));

    if (imagenPrincipal) {
      formData.append('imagen_principal', imagenPrincipal);
    }
    galeria.forEach(file => formData.append('galeria[]', file));

    axios.post(`${API_URL}lugares-turisticos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(() => {
        Swal.fire('Creado', 'Lugar turístico creado correctamente', 'success');
        setShowModal(false);
        limpiarCampos();
        return axios.get(`${API_URL}lugares-turisticos`);
      })
      .then(res => setLugares(res.data))
      .catch(err => {
        console.error('❌ Error al crear lugar turístico:', err);
        Swal.fire('Error', 'No se pudo crear el lugar', 'error');
      });
  };

  // Al actualizar un lugar existente
  const handleUpdateLugar = () => {
    if (!selectedLugar) return;

    const formData = new FormData();
    formData.append('nombre', nombre);
    formData.append('descripcion', descripcion);
    formData.append('info_destacada', infoDestacada);
    formData.append('sabias_que', sabiasQue);
    formData.append('url_mapa', urlMapa);
    formData.append('cronograma', cronograma);
    formData.append('precios', precios);

    // NUEVOS
    formData.append('precio_adultos', precioAdultos);
    formData.append('precio_ninos', precioNinos);

    formData.append('referencias', JSON.stringify(referencias));

    if (imagenPrincipal) {
      formData.append('imagen_principal', imagenPrincipal);
    }
    galeria.forEach(file => formData.append('galeria[]', file));

    axios.post(`${API_URL}lugares-turisticos/${selectedLugar.id}?_method=PUT`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(() => {
        Swal.fire('Actualizado', 'Lugar turístico actualizado correctamente', 'success');
        setIsEditing(false);
        setShowModal(false);
        return axios.get(`${API_URL}lugares-turisticos`);
      })
      .then(res => setLugares(res.data))
      .catch(err => {
        console.error('❌ Error al actualizar lugar turístico:', err);
        Swal.fire('Error', 'No se pudo actualizar el lugar', 'error');
      });
  };


  const limpiarCampos = () => {
    setNombre('');
    setDescripcion('');
    setInfoDestacada('');
    setSabiasQue('');
    setUrlMapa('');
    setImagenPrincipal(null);
    setGaleria([]);
    setReferencias([{ nombre: '', comentario: '', estrellas: 5 }]);
    setCronograma('');
    setPrecios('');

  };



  useEffect(() => {
    if (lugares.length > 0) {
      lugares.forEach(lugar => {
        if (lugar.galeria) {
          lugar.galeria.forEach(img => {
            console.log(`${API_URL_IMG}${img}`);
          });
        }
      });
    }
  }, [lugares]);


  useEffect(() => {
    axios
      .get(`${API_URL}lugares-turisticos`)
      .then((response) => {
        setLugares(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener los lugares turísticos:', error);
      });
  }, []);

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <h4 className="pb-3">Lugares Turísticos</h4>

      {/* Grid con cards */}
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
        {lugares.map((lugar) => (
          <div className="col" key={lugar.id}>
            <div className="card h-100 shadow">
              {lugar.galeria && lugar.galeria.length > 0 ? (
                <div id={`carousel-${lugar.id}`} className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {lugar.galeria.map((img, index) => (
                      <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                        <img
                          src={`${API_URL_IMG}${img}`}
                          className="d-block w-100"
                          style={{ height: '200px', objectFit: 'cover' }}
                          alt={`Lugar-${lugar.id}-img-${index}`}
                        />
                      </div>
                    ))}
                  </div>
                  {lugar.galeria.length > 1 && (
                    <>
                      <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${lugar.id}`} data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${lugar.id}`} data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </>
                  )}
                </div>
              ) : (
                <img
                  src="https://via.placeholder.com/400x200?text=No+Image"
                  alt="Sin imágenes"
                  className="card-img-top"
                  style={{ objectFit: 'cover', height: '200px' }}
                />
              )}

              <div className="card-body d-flex flex-column">
                <h5 className="card-title mb-1">{lugar.nombre}</h5>
                <p className="card-text fw-semibold">
                  {new Date(lugar.created_at).toLocaleDateString('es-ES')}
                </p>
                <p className="text-muted" style={{ fontSize: '0.875rem' }}>
                  {lugar.descripcion}
                </p>

                <div className="mt-auto">
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-primary flex-grow-1 me-2"
                      onClick={() => {
                        const lugarActualizado = lugares.find((l) => l.id === lugar.id);

                        setSelectedLugar(lugarActualizado);
                        setNombre(lugarActualizado?.nombre || '');
                        setDescripcion(lugarActualizado?.descripcion || '');
                        setInfoDestacada(lugarActualizado?.info_destacada || '');
                        setSabiasQue(lugarActualizado?.sabias_que || '');
                        setUrlMapa(lugarActualizado?.url_mapa || '');
                        setCronograma(lugarActualizado?.cronograma || '');
                        setPrecios(lugarActualizado?.precios || '');
                        setReferencias(Array.isArray(lugarActualizado?.referencias) ? lugarActualizado.referencias : [{ nombre: '', comentario: '', estrellas: 5 }]);
                        setIsEditing(false);
                        setShowModal(true);
                      }}

                    >
                      Ver detalles
                    </button>

                    <button className="btn btn-danger" onClick={() => handleDeleteLugar(lugar.id)}>
                      <i className="bx bx-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Card para añadir nuevo */}
        <div className="col">
          <div
            className="card shadow"
            style={{
              cursor: 'pointer',
              border: '2px dashed #0d6efd',
              backgroundColor: '#f8fbff',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              setSelectedLugar(null);
              setIsEditing(true);
              setShowModal(true);
            }}
          >
            <div className="text-center">
              <h1 style={{ fontSize: '4rem', color: '#0d6efd' }}>+</h1>
              <h6 className="mt-2 text-primary">Añadir Lugar Turístico</h6>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {selectedLugar ? 'Detalles del Lugar Turístico' : 'Agregar Nuevo Lugar Turístico'}
                    </h5>
                    <button type="button" className="btn-close" onClick={() => { setShowModal(false); setSelectedLugar(null); setIsEditing(false); }}></button>
                  </div>

                  <div className="modal-body">
                    {/* Todos los campos */}
                    {/* Nombre */}
                    <div className="mb-3">
                      <label className="form-label">Nombre</label>
                      <input type="text" className="form-control" value={nombre} onChange={(e) => setNombre(e.target.value)} readOnly={!isEditing} required />
                    </div>

                    {/* Descripción */}
                    <div className="mb-3">
                      <label className="form-label">Descripción</label>
                      <textarea className="form-control" rows={2} value={descripcion} onChange={(e) => setDescripcion(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* Info destacada */}
                    <div className="mb-3">
                      <label className="form-label">Información destacada</label>
                      <input type="text" className="form-control" value={infoDestacada} onChange={(e) => setInfoDestacada(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* Sabías que */}
                    <div className="mb-3">
                      <label className="form-label">¿Sabías qué?</label>
                      <input type="text" className="form-control" value={sabiasQue} onChange={(e) => setSabiasQue(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* URL Mapa */}
                    <div className="mb-3">
                      <label className="form-label">URL de Google Maps</label>
                      <input type="text" className="form-control" placeholder="https://www.google.com/maps?q=..." value={urlMapa} onChange={(e) => setUrlMapa(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* Cronograma */}
                    <div className="mb-3">
                      <label className="form-label">Cronograma</label>
                      <textarea className="form-control" rows={4} value={cronograma} onChange={(e) => setCronograma(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* Precios */}
                    <div className="mb-3">
                      <label className="form-label">Informacion de Precios</label>
                      <textarea className="form-control" rows={4} value={precios} onChange={(e) => setPrecios(e.target.value)} readOnly={!isEditing} />
                    </div>

                    {/* Dentro del modal, justo después del textarea de "Precios" */}
                    <div className="row g-3">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Precio Adultos</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          value={precioAdultos}
                          onChange={(e) => setPrecioAdultos(e.target.value)}
                          readOnly={!isEditing}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Precio Niños</label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          value={precioNinos}
                          onChange={(e) => setPrecioNinos(e.target.value)}
                          readOnly={!isEditing}
                        />
                      </div>
                    </div>



                    {/* Referencias */}
                    <div className="mb-3">
                      <label className="form-label">Referencias</label>
                      {referencias.map((ref, index) => (
                        <div className="border p-2 mb-2 rounded" key={index}>
                          <div className="row g-2 align-items-center">
                            <div className="col-md-4">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                value={ref.nombre}
                                onChange={(e) => handleReferenciaChange(index, 'nombre', e.target.value)}
                                readOnly={!isEditing}
                              />
                            </div>
                            <div className="col-md-5">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Comentario"
                                value={ref.comentario}
                                onChange={(e) => handleReferenciaChange(index, 'comentario', e.target.value)}
                                readOnly={!isEditing}
                              />
                            </div>
                            <div className="col-md-2">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="★"
                                min="1"
                                max="5"
                                value={ref.estrellas}
                                onChange={(e) => handleReferenciaChange(index, 'estrellas', e.target.value)}
                                readOnly={!isEditing}
                              />
                            </div>
                            <div className="col-md-1 text-end">
                              {isEditing && (
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => eliminarReferencia(index)} disabled={referencias.length === 1}>
                                  <i className="bx bx-trash"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                      {isEditing && (
                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={agregarReferencia}>
                          + Agregar referencia
                        </button>
                      )}
                    </div>

                    {/* Imagen principal y galería */}
                    {!selectedLugar && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">Imagen principal</label>
                          <input type="file" className="form-control" accept="image/*" onChange={handlePrincipalChange} />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Galería de imágenes</label>
                          <input type="file" className="form-control" multiple accept="image/*" onChange={handleGaleriaChange} />
                        </div>
                      </>
                    )}

                    {/* Previsualización galería */}
                    {!selectedLugar && galeria.length > 0 && (
                      <div className="row mt-2">
                        {galeria.map((file, index) => (
                          <div className="col-md-4 mb-3" key={index}>
                            <div className="card">
                              <div className="card-body p-2">
                                <img src={URL.createObjectURL(file)} alt="preview" className="img-fluid" style={{ height: '150px', objectFit: 'cover' }} />
                                <button type="button" className="btn btn-sm btn-danger mt-2" onClick={() => removeGaleriaImage(index)}>
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => { setShowModal(false); setSelectedLugar(null); setIsEditing(false); }}>
                      Cerrar
                    </button>

                    {selectedLugar && !isEditing && (
                      <button type="button" className="btn btn-warning" onClick={() => setIsEditing(true)}>
                        Editar
                      </button>
                    )}

                    {isEditing && (
                      <button type="button" className="btn btn-success" onClick={handleUpdateLugar}>
                        Actualizar
                      </button>
                    )}

                    {!selectedLugar && (
                      <button type="submit" className="btn btn-primary">
                        Guardar
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

}

export default LugaresAdmim;